import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { bindFunctionsToThis } from '../../extensions';

@Component({
    selector: 'ig-alt-button',
    templateUrl: './alt.button.component.html',
    styleUrls: ['./alt.button.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AltButtonComponent {
    @Output() public trigger = new EventEmitter<any>();
    @Output() public cancel = new EventEmitter<any>();

    constructor() {
        bindFunctionsToThis(this);
    }

    public btnClick() {
        this.trigger.emit();
    }

    public btnCancel($event: Event) {
        this.cancel.emit($event);
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/alt.button/alt.button.component.ts